<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="text-h6">
					<span>Detail Sales Delivery Order</span>
					<span class="pl-2 font-weight-bold">{{ detailSDO.sdo_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="4">
							<div class="body-2 oppacity-75">Dibuat Oleh</div>
							<div class="subtitle-2">{{ detailSDO.sdo_status_created_user_name }}</div>
							<div class="body-2 pt-3 oppacity-75">Tanggal Dibuat</div>
							<div class="subtitle-2">{{ detailSDO.sdo_status_created_datetime | tanggaljam }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<!-- <div v-if="detailSO.so_status == 'canceled'">
								<div class="body-2 oppacity-75">Dibatalkan Oleh</div>
								<div class="subtitle-2">{{ detailSO.so_status_canceled_user_name }}</div>
								<div class="body-2 pt-3 oppacity-75">Tanggal Dibatalkan</div>
								<div class="subtitle-2">{{ detailSO.so_status_canceled_datetime | tanggaljam }}</div>
							</div> -->
							<div>
								<div class="body-2 oppacity-75">Diterima Oleh</div>
								<div v-if="detailSDO.sdo_status_delivered_user_name < 1" class="subtitle-2">-</div>
								<div v-else class="subtitle-2">{{ detailSDO.sdo_status_delivered_user_name }}</div>
								<div class="body-2 pt-3 oppacity-75">Tanggal Diterima</div>
								<div v-if="detailSDO.so_status_delivered_datetime < 1" class="subtitle-2">-</div>
								<div v-else class="subtitle-2">{{ detailSDO.sdo_status_delivered_datetime | tanggaljam }}</div>
							</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="body-2 oppacity-75">Status</div>
							<div class="subtitle-2">{{ detailSDO.sdo_status | toStatusSDOWH }}</div>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailSDO.sdo_detail" hide-default-footer>
							<template v-slot:item.sdo_detail_quantity_sent="{ item }">
								<div>{{ item.sdo_detail_quantity_sent  | toNumber }}</div>
							</template>
							<template v-slot:item.sdo_detail_quantity_received="{ item }">
								<div>{{ item.sdo_detail_quantity_received  | toNumber }}</div>
							</template>
							<template v-slot:item.sdo_detail_product_price="{ item }">
								<div>{{ item.sdo_detail_product_price | toNumber }}</div>
							</template>
							<template v-slot:item.total_price="{ item }">
								<div v-if="item.sdo_detail_product_price <= 0">0</div>
								<div v-else>{{ item.sdo_detail_product_price * item.sdo_detail_quantity_sold  | toNumber }}</div>
							</template>
							<template v-slot:footer>
								<div class="d-flex justify-end pt-3">
									<div class="font-weight-bold text-right px-4">Total Pembayaran</div>
									<div class="font-weight-bold text-right px-4">{{ grandTotal | toRupiah }}</div>
								</div>
							</template>
						</v-data-table>
					</v-card>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'sdo_detail_product_name', sortable: false},
			{ text: 'Jumlah Dikirim', value: 'sdo_detail_quantity_sent', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'sdo_detail_quantity_received', sortable: false, align: 'center' },
			{ text: 'Harga(Rp)', value: 'sdo_detail_product_price', align: 'end'},
			{ text: 'Total Harga(Rp)', value: 'total_price', align: 'end', sortable: false},
			],
		}
	},
	computed:{
		...mapState('sdo', ['detailSDO']),

		grandTotal(){
			let total = 0
			if (this.detailSDO.sdo_detail) {
				this.detailSDO.sdo_detail.forEach( (el) => {
					total += el.sdo_detail_product_price * el.sdo_detail_quantity_sent
				});
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
	}
};
</script>
